import { render, staticRenderFns } from "./zzgz.vue?vue&type=template&id=3e2e1954&scoped=true&"
import script from "./zzgz.vue?vue&type=script&lang=js&"
export * from "./zzgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2e1954",
  null
  
)

export default component.exports